import { styled } from '@mui/material';

export const ConsentPageWrapper = styled('div')({
  width     : '100%',
  maxWidth  : '685px',
  margin    : '40px auto',
  padding   : '0 43px',
  boxSizing : 'border-box',
});

export const SectionHeader = styled('div')({
  '& > span' : {
    fontWeight : '700',
    lineHeight : '24px',
  },
  marginBottom : '18px',
  marginTop    : '33px',
});

export const List = styled('ul')(({ theme }) => ({
  listStyle    : 'none',
  fontFamily   : 'Montserrat',
  fontSize     : '14px',
  lineHeight   : '24px',
  paddingLeft  : 0,
  marginTop    : 0,
  marginBottom : '46px',
  '& li'       : {
    display      : 'flex',
    alignItems   : 'baseline',
    gap          : '10px',
    marginBottom : '15px',
    img          : {
      marginTop : '5px',
    },
  },
}));
